import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowLeft, FilmSlate } from "@phosphor-icons/react";
import api from "../api";
import VideoLibrary from "../components/VideoLibrary";

const GOLD = "#c9a24a";

// v414.80 — PUBLIC storefront Video Library at /{code}/videos.
// Same clips as the in-app library; shows NO pricing, codes or wholesale
// info (the library carries none by design). White + gold store styling.
export default function StoreVideosPage() {
  const { code } = useParams();
  const { t } = useTranslation();
  const [storeName, setStoreName] = useState("");

  useEffect(() => {
    api.get(`/store/${encodeURIComponent(code)}`)
      .then(({ data }) => setStoreName(data?.name || ""))
      .catch(() => {});
  }, [code]);

  useEffect(() => {
    const prev = document.title;
    document.title = `${t("library.title")} — ReUP Store`;
    return () => { document.title = prev; };
  }, [t]);

  return (
    <div className="min-h-screen bg-white" data-testid="store-videos-page">
      <div className="sticky top-0 z-30 bg-white/95 backdrop-blur border-b" style={{ borderColor: `${GOLD}44` }}>
        <div className="max-w-5xl mx-auto px-5 h-12 flex items-center justify-between gap-3">
          <Link
            to={`/${encodeURIComponent(code)}`}
            className="inline-flex items-center gap-1.5 text-sm font-semibold text-zinc-700 hover:text-zinc-950"
            data-testid="store-videos-back"
          >
            <ArrowLeft size={15} weight="bold" /> {t("library.back_to_store")}
          </Link>
          {storeName && (
            <span className="text-xs text-zinc-400 truncate">{storeName}</span>
          )}
        </div>
      </div>

      <div className="max-w-5xl mx-auto px-5 py-8 space-y-6">
        <div className="text-center">
          <p className="text-[11px] font-bold uppercase tracking-[0.2em]" style={{ color: GOLD }}>
            AXIS
          </p>
          <h1 className="text-2xl sm:text-3xl font-semibold tracking-tight text-zinc-950 flex items-center justify-center gap-2.5 mt-1">
            <FilmSlate size={26} weight="bold" style={{ color: "#8a6a1c" }} />
            {t("library.title")}
          </h1>
          <p className="text-sm text-zinc-600 mt-1">{t("library.store_subtitle")}</p>
        </div>
        <VideoLibrary />
      </div>
    </div>
  );
}
